import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import MeGate from "@/context/MeContext";
import { SignInPage, SignUpPage } from "@/pages/SignInPage";
import Dashboard from "@/pages/Dashboard";
import Kurse from "@/pages/Kurse";
import Alarme from "@/pages/Alarme";
import Wertstoffhoefe from "@/pages/Wertstoffhoefe";
import Metalle from "@/pages/Metalle";
import { useTheme } from "@/lib/theme";
import Anlieferungen from "@/pages/Anlieferungen";
import Benutzer from "@/pages/Benutzer";
import Einstellungen from "@/pages/Einstellungen";

const Protected = () => (
  <>
    <Show when="signed-in"><MeGate /></Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

function App() {
  const theme = useTheme();
  return (
    <div className="App grain">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/sign-up/*" element={<SignUpPage />} />
            <Route path="/" element={<Protected />}>
              <Route index element={<Dashboard />} />
              <Route path="kurse" element={<Kurse />} />
              <Route path="alarme" element={<Alarme />} />
              <Route path="metalle" element={<Metalle />} />
              <Route path="wertstoffhoefe" element={<Wertstoffhoefe />} />
              <Route path="anlieferungen" element={<Anlieferungen />} />
              <Route path="benutzer" element={<Benutzer />} />
              <Route path="einstellungen" element={<Einstellungen />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster richColors theme={theme} position="top-right" />
    </div>
  );
}

export default App;
